module.exports = __webpack_public_path__ + "img/5.07677df3.png";